import React from 'react';
import {NavLink} from 'react-router-dom';
import {
    HomeIcon,
    UserGroupIcon,
    AcademicCapIcon,
    UserPlusIcon,
    UsersIcon,
    BookOpenIcon,
    MusicalNoteIcon
} from '@heroicons/react/24/outline';

const navigation = [
    {
        name: 'Inicio',
        href: '/',
        icon: HomeIcon
    }, {
        name: 'Alumnos',
        href: '/alumnos',
        icon: UserGroupIcon
    }, {
        name: 'Clases',
        href: '/clases',
        icon: AcademicCapIcon
    }, {
        name: 'Asignación de Alumnos a Clases',
        href: '/asignacion',
        icon: UserPlusIcon
    }, {
        name: 'Profesores',
        href: '/profesores',
        icon: UsersIcon
    }, {
        name: 'Asignaturas',
        href: '/asignaturas',
        icon: BookOpenIcon
    }, {
        name: 'Instrumentos',
        href: '/instrumentos',
        icon: MusicalNoteIcon
    }
];

const Sidebar = () => {
    return (
        <div className="flex flex-col h-0 flex-1 border-r border-gray-200 bg-white">
            <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
                <div className="flex items-center flex-shrink-0 px-4 mb-8">
                    <div
                        className="h-10 w-10 bg-primary-600 rounded-lg flex items-center justify-center">
                        <span className="text-white font-bold text-xl">L</span>
                    </div>
                    <span className="ml-3 text-xl font-bold text-gray-900">LOME</span>
                </div>
                <nav className="mt-5 flex-1 px-2 space-y-1">
                    {
                        navigation.map((item) => (
                            <NavLink
                                key={item.name}
                                to={item.href}
                                className={(
                                    {isActive}) => `group flex items-center px-2 py-2 text-sm font-medium rounded-md ${
                                    isActive
                                    ? 'bg-primary-50 text-primary-700'
                                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`
}>
                                <item.icon
                                    className={`mr-3 flex-shrink-0 h-6 w-6 ${
                                    location.pathname === item.href
                                        ? 'text-primary-500'
                                        : 'text-gray-400 group-hover:text-gray-500'}`}
                                    aria-hidden="true"/> {item.name}
                            </NavLink>
                        ))
                    }
                </nav>
            </div>
        </div>
    );
};

export default Sidebar;
